<template>
  <common-dialog
    v-model="isOpen"
    ref="filterDialog"
    :checked="false"
    :not-visible="notVisible"
    :titleName="titleName"
    :search-disable="searchDisable"
    :content-css="{width : '380px', height: (notVisible)? '335px': '275px'}"
    :dialogEventHide="false"
    @hide="onHide"
    @show="onShow"
    @send="onSend"
  >
    <div class="content-group">
      <div class="contents-row">
        <table class="bs-table table-bordered-none">
          <colgroup>
            <col width="30%"/>
            <col width="auto"/>
          </colgroup>
          <tbody>
            <tr>
              <td class="td-head">
                <span>{{ type.toUpperCase() }} {{$t('lr.filterDateDialog_popup_input')}}</span>
                <p>({{$t('dash.filterExpIpMaxCnt', {cnt: maximumCnt})}})</p>
              </td>
              <td>
                <div class="block-group"><!-- class="block-group"은 세로 정렬 / class="inline-group"은 가로 정렬 -->
                  <ul class="block-group-ul"><!-- class="block-group-ul"은 세로 정렬 목록이 많을때 쓰입니다 -->
                    <li>
                      <m-input ref="inputField"
                               :type="type"
                               v-model="value"
                               @update="onInput"
                               :placeholder="placeholder"
                               style="width: 100%"
                               @keydown="onIpKeyDown"
                               :isNetMask="isNetMask"
                               :is-any-ip-use="isAnyIpUse"
                               :isRangeMultiUse="isRangeMultiUse"
                               name="inputField"
                               v-validate="getValidateIp"
                               is-btn-view/>
                    </li>
                    <li>
                      <m-list v-model="arrVal"/>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <validate-dialog ref="validateDialog"/>
  </common-dialog>
</template>

<script>
  import commonDialog from '../../common/Filter/filterCommonDialog'
  import Input from '../../common/Filter/common/filterInputField'
  import inputList from '../../common/Filter/common/filterInputDisplay'

  // mixins
  import filterValidateMixins from '~/mixins/filterValidate'

  export default {
    name: 'filter-exp-ip-dialog',
    props: {
      notVisible: {
        type: Boolean,
        default: false
      },
      multiformOnlyOne: { // 다중 형식을 허용할 것인지 여부 (NetMask가 있거나 범위 입력일 경우 콤마 입력 불가)
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'ip'
      },
      isAnyIpUse: { // IP에 ANY 사용 여부
        type: Boolean,
        default: false
      },
      maximumCnt: { // 등록할 수 있는 최대 IP 수
        type: Number,
        default: 20
      }
    },
    components: {
      'common-dialog': commonDialog,
      'm-input': Input,
      'm-list': inputList
    },
    mixins: [
      filterValidateMixins
    ],
    data () {
      return {
        isOpen: false,
        isRangeMulti: true, // 범위 입력 시 여러개 입력 여부 (default: true)
        value: '',
        arrVal: [],
        titleName: '',
        data: { },
        searchDisable: false,
        isNetMask: true,
        isRangeMultiUse: true,
        isNotMultiIp: false,
        // 분석 > 개별 필터에서 리스트 타입의 필터를 수정할 때 사용한다.
        analysisPanel: null
      }
    },
    computed: {
      placeholder () {
        if (this.type === 'ip') {
          return 'IPv4 or IPv6 Address'
        } else if (this.type === 'ipv4') {
          return 'IPv4 Address'
        } else if (this.type === 'ipv6') {
          return 'IPv6 Address'
        }
        return 'Mac Address'
      },
      getValidateIp () {
        if (this.isAnyIpUse && (this.value === 'ANY' || this.value === 'any' || this.value === 'Any')) {
          return ''
        }
        if ((this.type.indexOf('ip') > -1)) {
          if (this.isNetMask) {
            return 'isValidIPv4IPv6'
          } else {
            return 'isValidIPv4IPv6NoNetMask'
          }
        } else {
          return 'isValidMac'
        }
      }
    },
    methods: {
      onIpKeyDown (e) {
        if (this.multiformOnlyOne && e.key === ',') {
          const isRange = this.value.indexOf('-') > -1
          if (this.isNetMask) {
            const _isNetMask = this.value.indexOf('/') > -1
            if (isRange || _isNetMask) {
              e.returnValue = false
            }
          } else {
            if (isRange) {
              e.returnValue = false
            }
          }
        }
      },
      async onInput (val) {
        if (this.maximumCnt === this.arrVal.length) {
          this.$alertPopUp.show(this.$t('dash.filterExpIpMaxAlert', {cnt: this.maximumCnt}))
          return
        }
        if (this.multiformOnlyOne) {
          const arrFilter = _.filter(this.arrVal, (val2) => { return val2.indexOf('-') > -1 || val2.indexOf('/') > -1 })
          const isRange = val.indexOf('-') > -1
          const _isNetMask = val.indexOf('/') > -1
          if (this.isNetMask) {
            if (this.arrVal.length > 0 && (isRange || _isNetMask || arrFilter.length > 0)) {
              this.$alertPopUp.show(this.$t('lr.log_msg_addressInputMulti'))
              return
            }
          } else {
            if (this.arrVal.length > 0 && (isRange || arrFilter.length > 0)) {
              this.$alertPopUp.show(this.$t('lr.log_msg_addressInputMulti_1'))
              return
            }
          }
        }
        if (this.isNotMultiIp) {
          const isIPv4 = val.indexOf('.') > -1
          const isIPv6 = val.indexOf(':') > -1
          if (isIPv4) {
            const arrFilter = _.filter(this.arrVal, (val2) => { return val2.indexOf(':') > -1 })
            if (arrFilter.length > 0) {
              this.$alertPopUp.show(this.$t('lr.status_msg_addressInputNotMulti'))
              return
            }
          } else if (isIPv6) {
            const arrFilter = _.filter(this.arrVal, (val2) => { return val2.indexOf('.') > -1 })
            if (arrFilter.length > 0) {
              this.$alertPopUp.show(this.$t('lr.status_msg_addressInputNotMulti'))
              return
            }
          }
        }
        const checkValidate = await this.validate()
        const isNext = (this.isRangeMulti) ? this.filterValidate(val, this.arrVal) : this.filterValidateNotRangeMulti(val, this.arrVal)
        if (checkValidate && isNext) {
          this.arrVal.push(val)
          this.value = ''
        }
      },
      onSend (sendD) {
        // validation check
        const paramD = this.data
        if (sendD.type === 'remove') {
          this.value = ''
          this.arrVal = []
        } else {
          if (paramD !== undefined) {
            paramD.filter = this.$refs.inputField.getInputDataArr(this.arrVal)
          }
          this.$emit(sendD.type, paramD, this.analysisPanel || null)
          this.hide()
        }
      },
      async validate () {
        await this.$validator.validateAll()
        if (this.$validator.errors.count() === 0) {
          return true
        }
        this.$refs.validateDialog.show(this.$validator.errors.items)
        return false
      },
      onHide () {
        this.$emit('hide')
      },
      onShow () {
        this.$emit('show')
      },
      show (data, btnDisable = false, analysisPanel = null) {
        this.data = data
        this.analysisPanel = analysisPanel
        this.searchDisable = btnDisable
        this.value = ''
        this.titleName = this.data.name
        if (this.data.filter !== undefined) {
          this.arrVal = _.cloneDeep(this.data.filter)
        }
        // IP 필터에 NetMask 포함 여부 포함=true, 미포함=false
        if (this.data.isNetMask !== undefined) {
          this.isNetMask = this.data.isNetMask
        }

        // mac 필터에 isMacRangeMulti 범위 지정 가능 여부 isMacRangeMulti=false 범위 지정 불가
        if (this.data.isRangeMultiUse !== undefined) {
          this.isRangeMultiUse = this.data.isRangeMultiUse
        }

        if (this.data.isRangeMulti !== undefined) {
          this.isRangeMulti = this.data.isRangeMulti
        } else {
          this.isRangeMulti = true
        }

        // // IPv4, IPv6  IP 혼용 허용 여부 (isNotMultiIp = true : 혼용 안됨)
        if (this.data.isNotMultiIp !== undefined) {
          this.isNotMultiIp = this.data.isNotMultiIp
        }

        this.$refs.filterDialog.show()
      },
      hide () {
        this.clearData()
        this.analysisPanel = null
        this.$refs.filterDialog.hide()
      },
      clearData () {
        this.isOpen = false
        this.isRangeMulti = true // 범위 입력 시 여러개 입력 여부 (default = true)
        this.value = ''
        this.arrVal = []
        this.data = { }
        this.searchDisable = false
        this.isNetMask = true
        this.isRangeMultiUse = true
        this.isNotMultiIp = false
      }
    }
  }
</script>

<style scoped>

</style>
